import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Divider, Grid, Text, Tooltip } from '@chakra-ui/react';
import { styles } from './admin-template.styles';
import { SecondaryNavigation, SecondaryNavigationOrientation, SecondaryNavigationVariants } from '../secondary-navigation/secondary-navigation';
import { useDispatch, useSelector } from 'react-redux';
import theme from '../../theme';
import { navigate } from '../../actions/organization';
import { Breadcrumbs } from '../breadcrumbs/breadcrumbs';
import Admin from '../../views/admin/admin-component';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
const convertToTabsDto = (tabItems)=>tabItems.map((item)=>({
            label: item?.displayName ?? ''
        }));
const adminPath = {
    link: false,
    display: false,
    data: {},
    displayName: 'Admin'
};
// Moves organization TabDef to the first index
const unshiftOrg = (arr)=>{
    const tempArr = JSON.parse(JSON.stringify(arr));
    const index = tempArr.findIndex((item)=>item?.resourceId === 'organizations');
    const obj = tempArr.splice(index, 1)[0];
    tempArr.unshift(obj);
    return tempArr;
};
const AdminTemplate = (props)=>{
    const { items, title } = props;
    const tabItems = useMemo(()=>unshiftOrg(items), [
        items
    ]);
    const classes = styles();
    const dispatch = useDispatch();
    const { path, activeOrganization } = useSelector((state)=>state.organization);
    const { auth } = useSelector((state)=>state.login);
    // This will return active tab index based on the path
    const getActiveAdminTabIndex = ()=>{
        if (window.location.toString().includes('users')) {
            return tabItems.findIndex((item)=>item?.resourceId === 'users');
        } else if (window.location.toString().includes('auditLog')) {
            return tabItems.findIndex((item)=>item?.resourceId === 'audit_log');
        }
        return 0;
    };
    const [activeTab, setActiveTab] = useState(getActiveAdminTabIndex());
    const handleTabsChange = (e)=>{
        setActiveTab(e);
        props.onSelection({
            ...tabItems[e],
            path: `${tabItems[e].path}`
        });
    };
    const navigateTo = (token, organization)=>{
        dispatch(navigate({
            token,
            organization
        }));
    };
    return /*#__PURE__*/ _jsxs("div", {
        style: classes.root,
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: classes.header,
                children: path?.length && activeTab === 0 ? /*#__PURE__*/ _jsx(Breadcrumbs, {
                    paths: [
                        adminPath,
                        ...path
                    ],
                    isPrimary: true,
                    onCrumbClick: (data)=>auth && navigateTo(auth, data)
                }) : /*#__PURE__*/ _jsx(Text, {
                    className: "admin-text-qa",
                    sx: classes.text,
                    children: title
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                style: classes.content,
                children: [
                    path?.length > 1 && activeTab === 0 ? /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsxs(Grid, {
                                display: "flex",
                                "flex-direction": "row",
                                alignItems: 'baseline',
                                columnGap: theme.space[12],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: classes.headerText,
                                        children: activeOrganization?.displayName
                                    }),
                                    activeOrganization.address1 && /*#__PURE__*/ _jsx(Tooltip, {
                                        label: /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: activeOrganization.address1
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: activeOrganization.address2
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        activeOrganization.city,
                                                        ", ",
                                                        activeOrganization.state,
                                                        ' ',
                                                        activeOrganization.zipCode
                                                    ]
                                                })
                                            ]
                                        }),
                                        placement: "bottom",
                                        children: /*#__PURE__*/ _jsx(BiomeIcon, {
                                            iconName: IconName.Info,
                                            iconClass: `${classes.InfoIcon}`
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                borderColor: theme.colors.foundation[100],
                                orientation: "horizontal"
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(SecondaryNavigation, {
                        data: convertToTabsDto(tabItems),
                        variant: SecondaryNavigationVariants.LINE,
                        orientation: SecondaryNavigationOrientation.HORIZONTAL,
                        tabIndex: activeTab,
                        handleTabsChange: handleTabsChange
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: classes.adminOutlet,
                        children: /*#__PURE__*/ _jsx(Admin, {})
                    })
                ]
            })
        ]
    });
};
AdminTemplate.displayName = 'Admin Template';
const MemoizedAdminTemplate = /*#__PURE__*/ React.memo(AdminTemplate);
export { MemoizedAdminTemplate as AdminTemplate };
